import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

interface Props {
  title?: string;
}
export const Page: React.FC<Props> = ({ title, children }) => (
  <div
    css={css`
      margin: 0px auto;
      padding: 20px 30px;
      max-width: 1024px;
    `}
  >
    {title && <h1>{title}</h1>}
    {children}
  </div>
);
